import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";

interface PrivateAssetData {
  assetUrl: string;
}

export const QUERY_KEY = "getPrivateAsset";

export const useGetPrivateAsset = (params: {
  assetUrl: string | null;
  isPrivateImage: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY, params.assetUrl],
    queryFn: async (): Promise<PrivateAssetData> => {
      if (params.isPrivateImage && params.assetUrl) {
        const response = await apiClient.get<PrivateAssetData>(
          API_ROUTES.privateAsset,
          {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              assetUrl: params.assetUrl,
            },
          }
        );
        return response.data;
      } else {
        return { assetUrl: params.assetUrl ?? "" };
      }
    },
  });
};
